import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importRewardHistoryContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "RewardHistoryContainer" */
                '@perpay-web/fintech/components/containers/RewardHistoryContainer'
            ),
    );
